import { render, staticRenderFns } from "./TaTextLeftLanding.vue?vue&type=template&id=e578aee2&scoped=true&"
import script from "./TaTextLeftLanding.vue?vue&type=script&lang=js&"
export * from "./TaTextLeftLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e578aee2",
  null
  
)

export default component.exports